// userSelectors.js

export const selectLoading = (state) => state.planMySurgery.loading;
export const selectTreatmentData = (state) => state.planMySurgery.treatmentData;
export const selectSugeryData = (state) => state.planMySurgery.successData;
